import classNames from 'classnames/bind';
import React from 'react';
import FlexPanel from './FlexPanel';
import Style from './assets/css/style.scss';
import {
	IComponentList,
	IFlexLayoutBaseClickEventArgs,
	IFlexLayoutProps,
	IFlexPanel,
	IFlexPanelAnimationEndEvent,
	IFlexPanelClickEventArgs,
	IFlexPanelContentComponent,
	IFlexPanelProps
} from './entities';
import * as FlexPanelActionTypes from './entities/ActionTypes';
import IFlexPanelComponent from './entities/IFlexPanelComponent';
import IFlexPanelComponentProps from './entities/IFlexPanelComponentProps';
const cx = classNames.bind(Style);

const BCFlexLayout = (props: IFlexLayoutProps) => {
	const staticHeight = React.useRef<React.CSSProperties>(null);
	React.useEffect(() => {
		props.onCreate?.();
	}, []);

	const onFlexPanelClick = (args: IFlexPanelClickEventArgs) => {
		args.senderArgs.persist();
		props.onFlexPanelClick?.(args);
	};

	const onFlexPanelMaximizeClick = (args: IFlexPanelClickEventArgs) => {
		args.senderArgs.persist();
		args.senderArgs.stopPropagation();
		props.onFlexPanelMaximizeClick?.(args);
	};

	const onFlexPanelCloseClick = (args: IFlexPanelClickEventArgs) => {
		args.senderArgs.persist();
		args.senderArgs.stopPropagation();
		props.onFlexPanelCloseClick?.(args);
	};

	const onAnimationEnd = (args: IFlexPanelAnimationEndEvent) => {
		props.onAnimationEnd?.(args);
	};

	const { items, components, breakpoint } = props;

	staticHeight.current = props.fromMobile ? { height: window.innerHeight } : null;

	const renderFlexPanel = (item: IFlexPanel, index: number) => {
		if (!item.isVisible || !item.isOnScreen) {
			return;
		}
		const list: Array<IFlexPanelComponent> = item.componentKeys.map((componentKey: string) => {
			let componentProps: IFlexPanelComponentProps;
			if (item.componentProps && Array.isArray(item.componentProps)) {
				item.componentProps.forEach(currentCompProps => {
					if (currentCompProps.componentKey === componentKey) {
						componentProps = {
							...currentCompProps.props,
							key: item.id
						};
					}
				});
			}
			return {
				component: components[componentKey],
				props: componentProps ? { ...componentProps } : { key: index }
			};
		});

		return (
			<FlexPanel
				key={item.id}
				id={item.id}
				title={item.title}
				subtitle={item.subtitle}
				isActive={item.isActive}
				isOnScreen={item.isOnScreen}
				isVisible={item.isVisible}
				isMaximized={breakpoint ? false : item.isMaximized}
				isCloseButtonHide={item.isCloseButtonHide}
				isHeaderAreaHide={item.isHeaderAreaHide}
				isMaximizeButtonHide={breakpoint ? true : item.isMaximizeButtonHide}
				isTitleHide={item.isTitleHide}
				animationCssClass={item.animationCssClass}
				size={item.size}
				isStartupPanel={item.isStartupPanel}
				initialSize={item.initialSize}
				prevSize={item.prevSize}
				ghostPanel={item.ghostPanel}
				onPanelClick={onFlexPanelClick}
				onCloseClick={onFlexPanelCloseClick}
				onMaximizeClick={onFlexPanelMaximizeClick}
				onAnimationEnd={onAnimationEnd}
				components={list}
				isHeaderActionsHide={item.isHeaderActionsHide}
				fromMobile={item.fromMobile}
				isTransparentBackground={item.isTransparentBackground}
				hideScrollbar={item.hideScrollbar}
			/>
		);
	};

	return (
		<div
			className={cx({ flexPanelContainer: true, fromMobile: props.fromMobile })}
			style={staticHeight.current}
		>
			{items?.length
				? props.items.map((item: IFlexPanel, index: number) => renderFlexPanel(item, index))
				: null}
		</div>
	);
};

export default BCFlexLayout;
export {
	IComponentList,
	IFlexLayoutBaseClickEventArgs,
	IFlexLayoutProps,
	IFlexPanel,
	IFlexPanelAnimationEndEvent,
	IFlexPanelClickEventArgs,
	IFlexPanelContentComponent,
	IFlexPanelProps,
	FlexPanelActionTypes
};
